export default __webpack_public_path__ + "static/media/ge2.88ff87e2.jpg";